<template>
    <div v-if="$auth.check()">
        <v-row align="center">
            <v-col cols="12" sm="8">
                <h1>Visão geral</h1>
            </v-col>
            <v-col cols="12" sm="4" class="text-sm-right">
                <v-btn color="primary" @click="load()" :disabled="loading">
                    <v-icon left>mdi-refresh</v-icon>atualizar
                </v-btn>
            </v-col>
        </v-row>

        <v-progress-linear indeterminate color="primary" class="mb-2" v-if="loading || loading_ont"></v-progress-linear>

        <v-row>
            <v-col cols="12" sm="6" md="3">
                <v-card>
                    <v-card-text>
                        <div class="text-overline">OLTs</div>
                        <div class="text-h4 primary--text">{{ olts.length }}</div>
                        <div class="text-caption">{{ counterInterface }} interfaces monitoradas</div>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="3">
                <v-card>
                    <v-card-text>
                        <div class="text-overline">ONTs cadastradas</div>
                        <div class="text-h4">
                            <span v-if="loading_ont">--</span>
                            <span v-else>{{ counter_ont }}</span>
                        </div>
                        <div class="text-caption">{{ totalPorts }} service-ports</div>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="3">
                <v-card>
                    <v-card-text>
                        <div class="text-overline">Service-ports UP</div>
                        <div class="text-h4 success--text">{{ totalUp }}</div>
                        <div class="text-caption">{{ availability }}% disponíveis</div>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="3">
                <v-card>
                    <v-card-text>
                        <div class="text-overline">Service-ports DOWN</div>
                        <div class="text-h4 error--text">{{ totalDown }}</div>
                        <div class="text-caption">{{ criticalInterfaces.length }} interfaces críticas</div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-card class="mt-4">
            <v-card-title>Status por OLT</v-card-title>
            <v-card-text>
                <v-alert dense text type="info" v-if="!loading && olts.length == 0">
                    Nenhuma OLT cadastrada
                </v-alert>
                <v-simple-table v-else>
                    <thead>
                        <tr>
                            <th>Código</th>
                            <th>Nome</th>
                            <th>Host</th>
                            <th>Interfaces</th>
                            <th>Total</th>
                            <th>UP</th>
                            <th>DOWN</th>
                            <th>Disponibilidade</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in olts" :key="item.id">
                            <td>{{ item.code }}</td>
                            <td>{{ item.name }}</td>
                            <td>{{ item.host }}</td>
                            <td>{{ item.interfaces.length }}</td>
                            <td>{{ item.total }}</td>
                            <td class="success--text">{{ item.up }}</td>
                            <td class="error--text">{{ item.down }}</td>
                            <td style="min-width: 140px">
                                <v-alert dense text type="warning" class="ma-0 py-1" v-if="item.failed">
                                    sem dados
                                </v-alert>
                                <div v-else-if="item.total > 0">
                                    <v-progress-linear
                                        :value="pct(item.up, item.total)"
                                        :color="barColor(item)"
                                        height="16"
                                    >
                                        <span class="text-caption">{{ pct(item.up, item.total) }}%</span>
                                    </v-progress-linear>
                                </div>
                                <span v-else>-</span>
                            </td>
                            <td style="white-space: nowrap">
                                <v-btn small color="success" @click="admin(item.id)">administração</v-btn>&nbsp;&nbsp;
                                <v-btn small color="warning" @click="status(item.id)">status</v-btn>
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-card-text>
        </v-card>

        <v-card class="mt-4">
            <v-card-title>
                Interfaces críticas
                <v-chip class="ml-2" small color="error" v-if="criticalInterfaces.length > 0">
                    {{ criticalInterfaces.length }}
                </v-chip>
            </v-card-title>
            <v-card-subtitle>50% ou mais dos service-ports em DOWN</v-card-subtitle>
            <v-card-text>
                <v-alert dense text type="success" v-if="!loading && criticalInterfaces.length == 0">
                    Nenhuma interface com 50% ou mais dos service-ports em DOWN
                </v-alert>
                <v-simple-table v-else>
                    <thead>
                        <tr>
                            <th>OLT</th>
                            <th>Interface</th>
                            <th>Total</th>
                            <th>UP</th>
                            <th>DOWN</th>
                            <th>% DOWN</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in criticalInterfaces" :key="index" style="background-color: #ff6961">
                            <td>{{ item.oltName }}</td>
                            <td>{{ item.fsp }}</td>
                            <td>{{ item.total }}</td>
                            <td>{{ item.up }}</td>
                            <td>{{ item.down }}</td>
                            <td>{{ pct(item.down, item.total) }}%</td>
                            <td>
                                <v-btn small color="warning" @click="status(item.oltId)">status</v-btn>
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import api from "../api/index.js";
export default {
    data: () => ({
        olts: [],
        counter_ont: 0,
        loading: false,
        loading_ont: false
    }),
    created: function() {
        this.load();
    },
    computed: {
        counterInterface: function() {
            return this.olts.reduce(function(acc, olt) {
                return acc + olt.interfaces.length;
            }, 0);
        },
        totalPorts: function() {
            return this.olts.reduce(function(acc, olt) {
                return acc + olt.total;
            }, 0);
        },
        totalUp: function() {
            return this.olts.reduce(function(acc, olt) {
                return acc + olt.up;
            }, 0);
        },
        totalDown: function() {
            return this.olts.reduce(function(acc, olt) {
                return acc + olt.down;
            }, 0);
        },
        availability: function() {
            return this.pct(this.totalUp, this.totalPorts);
        },
        criticalInterfaces: function() {
            var list = [];
            this.olts.forEach(function(olt) {
                olt.interfaces.forEach(function(item) {
                    // critica = metade ou mais dos service-ports em DOWN
                    if (item.total > 0 && item.down / item.total >= 0.5) {
                        list.push(item);
                    }
                });
            });
            var me = this;
            list.sort(function(a, b) {
                var diff = me.pct(b.down, b.total) - me.pct(a.down, a.total);
                if (diff != 0) {
                    return diff;
                }
                return b.down - a.down;
            });
            return list;
        }
    },
    methods: {
        load: function() {
            this.loadOlts();
            this.loadOnts();
        },
        loadOlts: function() {
            var me = this;
            var token = localStorage.getItem("token");
            var config = { headers: { Authorization: "Bearer " + token } };
            me.loading = true;
            api
                .get("/olt", config)
                .then(function(response) {
                    var olts = response.data || [];
                    return Promise.all(
                        olts.map(function(olt) {
                            return api
                                .get("/olt_service_port/status/" + olt.id, config)
                                .then(function(res) {
                                    return me.processOlt(olt, res.data || [], false);
                                })
                                .catch(function(error) {
                                    console.log(error);
                                    return me.processOlt(olt, [], true);
                                });
                        })
                    );
                })
                .then(function(list) {
                    me.olts = list;
                })
                .catch(function(error) {
                    console.log(error);
                    alert("Erro ao carregar o painel");
                })
                .finally(() => {
                    me.loading = false;
                });
        },
        loadOnts: function() {
            var me = this;
            var token = localStorage.getItem("token");
            me.loading_ont = true;
            api
                .get("/ont", { headers: { Authorization: "Bearer " + token } })
                .then(function(response) {
                    me.counter_ont = (response.data || []).length;
                })
                .catch(function(error) {
                    console.log(error);
                })
                .finally(() => {
                    me.loading_ont = false;
                });
        },
        processOlt: function(olt, sports, failed) {
            let cache = {};
            let up = 0;
            let down = 0;
            let total = 0;
            for (var i = 0; i < sports.length; i++) {
                const sp = sports[i];
                let fsp = cache[sp.fsp];
                if (!fsp) {
                    fsp = {
                        oltId: olt.id,
                        oltName: olt.name,
                        fsp: sp.fsp,
                        up: 0,
                        down: 0,
                        total: 0
                    };
                    cache[sp.fsp] = fsp;
                }
                if (sp.status == "up") {
                    fsp.up++;
                    fsp.total++;
                    up++;
                    total++;
                } else if (sp.status == "down") {
                    fsp.down++;
                    fsp.total++;
                    down++;
                    total++;
                }
            }
            let interfaces = Object.keys(cache).map(function(key) {
                return cache[key];
            });
            return {
                id: olt.id,
                code: olt.code,
                name: olt.name,
                host: olt.host,
                up: up,
                down: down,
                total: total,
                interfaces: interfaces,
                failed: failed
            };
        },
        pct: function(part, total) {
            if (!total) {
                return 0;
            }
            return Math.round((part / total) * 1000) / 10;
        },
        barColor: function(item) {
            let dp = item.down / item.total;
            if (dp > 0.4) {
                return "error";
            } else if (dp > 0.2) {
                return "warning";
            }
            return "success";
        },
        admin: function(id) {
            this.$router.push({ path: `/olt/admin/${id}` });
        },
        status: function(id) {
            this.$router.push({ path: `/olt/status/${id}` });
        }
    }
};
</script>
